<template>
  <div
    class="app"
    :class="{
      'touch-none': isShowMapCatalog,
      'pb-24 md:pb-0': isLotRoute
    }"
  >
    <RmHeader />
    <GlobalComponents />
    <div
      v-show="isShowCategoriesMenu && isLotRoute"
      class="is-shadow"
    />
    <NuxtPage :keepalive="{ max: 10, include: ['CityCatalogIndexPage', 'CityCatalogSlugPage'] }" />
    <RmFooter v-if="!isShowMapCatalog" />
    <div
      v-if="isShowMapCatalog"
      class="sticky w-full bottom-0 left-0 right-0 h-7 opacity-0 md:hidden"
    />
    <MobileNav
      v-if="!isLotRoute"
      class="md:hidden"
    />
  </div>
</template>

<script setup>
import isEmpty from 'es-toolkit/compat/isEmpty'
import RmFooter from '~/components/footer'
import RmHeader from '~/components/header'
import GlobalComponents from '~/components/layout/global_components.vue'
import MobileNav from '~/components/layout/mobile_nav.vue'

const route = useRoute()
const { $tracking } = useNuxtApp()

const search = useSearch()
const searchForm = useSearchForm()

const isShowMap = searchForm.isShowMap
const selectedCategory = searchForm.selectedCategory
const fromBack = computed(() => useGlobal().fromBack.value)
const isShowCategoriesMenu = useGlobal().isShowCategoriesMenu

// Layout общий для каталога и лота, поэтому флаги и chrome зависят от маршрута, а не от факта mount layout
const isCatalogRoute = computed(() => String(route.name || '').includes('city-catalog'))
const isLotRoute = computed(() => String(route.name || '').includes('lots-id'))
const isShowMapCatalog = computed(() => isShowMap.value && isCatalogRoute.value)
// Watchers
watch(isShowMap, (newValue, oldValue) => {
  if (newValue && !oldValue) {
    const sortBy = route.query.sort_by || 'RELEVANCE'
    const direction = route.query.direction || 'DESC'
    const SORT_BY = sortBy ? sortBy.toUpperCase() + '_' + direction.toUpperCase() : ''

    const getItemCategory = useCategories().getItemCategory(
      selectedCategory.value.id,
    )
    const getItemCategory2 = useCategories().getItemCategory2(
      selectedCategory.value.id,
    )
    const getItemCategory3 = useCategories().getItemCategory3(
      selectedCategory.value.id,
    )
    const getItemCategory4 = useCategories().getItemCategory4(
      selectedCategory.value.id,
    )

    if (fromBack.value) {
      return
    }

    setTimeout(() => {
      $tracking.logEventAmplitude('view map', {
        'product list': selectedCategory.value?.id && selectedCategory.value.id,
        'category id': selectedCategory.value?.id && selectedCategory.value.id,
        'category name': selectedCategory.value?.name && selectedCategory.value.name,
        'category depth': isEmpty(selectedCategory.value) ? 0 : selectedCategory.value.depth + 1,
        'category level 1 name': getItemCategory,
        ...(getItemCategory2 && {
          'category level 2 name': getItemCategory2,
        }),
        ...(getItemCategory3 && {
          'category level 3 name': getItemCategory3,
        }),
        ...(getItemCategory4 && {
          'category level 4 name': getItemCategory4,
        }),
        'sort type': SORT_BY,
        query: route.query.q || '',
        'num of products': search.totalCount.value,
      })
    }, 2000)
  }
})

onMounted(() => {
  useGlobal().setIsLayoutCatalog(isCatalogRoute.value)
})

watch(isCatalogRoute, (value) => {
  useGlobal().setIsLayoutCatalog(value)
})

// Срабатывает только при уходе из секции каталог/лот (смена layout) — переход catalog → lot больше не размонтирует layout
onUnmounted(() => {
  searchForm.setIsShowMap(false)
  search.setLotsBbox([])
  searchForm.setGeoBoundingBox({})
  useGlobal().setFromBack(false)
  searchForm.clearAll()
  useGlobal().setIsLayoutCatalog(false)
})
</script>
